import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import {
  WithdrawalRequest,
  WithdrawalResponse,
} from '../core/state/earnings/withdrawal.model';

@Injectable({ providedIn: 'root' })
export class WithdrawalApiService {
  private http = inject(HttpClient);
  private baseUrl = environment.host;

  requestWithdrawal(amount?: number) {
    return this.http.post<WithdrawalRequest>(
      this.baseUrl + '/api/v1/withdrawal',
      amount !== undefined ? { amount } : {}
    );
  }

  getOwn(page = 1, limit = 10) {
    return this.http.get<WithdrawalResponse>(
      `${this.baseUrl}/api/v1/withdrawal?page=${page}&limit=${limit}`
    );
  }

  getAll(page = 1, limit = 10, status?: string) {
    let url = `${this.baseUrl}/api/v1/withdrawal/all?page=${page}&limit=${limit}`;
    if (status) url += `&status=${encodeURIComponent(status)}`;
    return this.http.get<WithdrawalResponse>(url);
  }

  markCompleted(id: string, adminNote?: string, proofResourceId?: string) {
    return this.http.put<WithdrawalRequest>(
      `${this.baseUrl}/api/v1/withdrawal/${id}/complete`,
      { adminNote, proofResourceId }
    );
  }

  markRejected(id: string, adminNote?: string) {
    return this.http.put<WithdrawalRequest>(
      `${this.baseUrl}/api/v1/withdrawal/${id}/reject`,
      { adminNote }
    );
  }
}
